import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Tabs, Tab } from "../../components/Tab";
import ImageSlider from "../../components/ImageSlider";

const MainHomePage = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1100);
  const [consultButton, setConsultButton] = useState<boolean>(false);
  const [isVisible, setIsVisible] = useState<boolean[]>([false]);
  const bannerImages = isMobile
    ? [
        {
          src: "https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobileBanner01.png",
          borderColor: "#C7C7C7",
          color: "#555555",
          svgSrc: `${process.env.PUBLIC_URL}/svg/rightArrowGray.svg`,
          className: "bannerImage01",
        },
        {
          src: "https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobileBanner02.png",
          borderColor: "#fff",
          color: "#fff",
          svgSrc: `${process.env.PUBLIC_URL}/svg/rightArrowWhite.svg`,
          className: "bannerImage02",
        },
      ]
    : [
        {
          src: "https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webBanner01.jpg",
          borderColor: "#C7C7C7",
          color: "#555555",
          svgSrc: `${process.env.PUBLIC_URL}/svg/rightArrowGray.svg`,
          className: "bannerImage01",
        },
        {
          src: "https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webBanner02.jpg",
          borderColor: "#fff",
          color: "#fff",
          svgSrc: `${process.env.PUBLIC_URL}/svg/rightArrowWhite.svg`,
          className: "bannerImage02",
        },
      ];

  // 링크이동
  const kakaoTalk = () => {
    window.open("http://pf.kakao.com/_DwSAG/chat", "_blank");
  };

  // text 애니메이션
  const hideRefs = [
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
    useRef<HTMLHeadingElement>(null),
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;

      hideRefs.forEach((ref, index) => {
        const element = ref.current;
        if (element) {
          const elementTop = element.offsetTop;
          const elementHeight = element.offsetHeight;
          const isElementVisible =
            scrollTop + windowHeight > elementTop &&
            scrollTop < elementTop + elementHeight;
          setIsVisible((prev) => {
            const newVisible = [...prev];
            newVisible[index] = isElementVisible;
            return newVisible;
          });
        }
      });

      if (scrollTop + windowHeight === documentHeight) {
        setIsVisible((prev) => {
          const newVisible = [...prev];
          newVisible[newVisible.length - 1] = true;
          return newVisible;
        });
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1100);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Style>
      <div className="wrapper">
        <div className="banner">
          <ImageSlider images={bannerImages} type="buttonTrue" />
        </div>
        <div className="content">
          <div className="title">
            <h1
              ref={hideRefs[0]}
              className={` ${isVisible[0] ? "in_view fade_up" : "fade_up"}`}
            >
              비하인드로 성공을 앞당기세요!
            </h1>
            <h3>비하인드를 사용하고 매출을 증대시켜 보세요.</h3>
          </div>
          <img
            src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webHomepage01.png"
            alt="비하인드를 사용하고 매출을 증대시켜 보세요"
            className="webHomepage01"
          />
        </div>
        <div className="content">
          <div className="title webView">
            <h1>
              비하인드가
              <span
                ref={hideRefs[1]}
                className={` ${isVisible[1] ? "in_view fade_in" : "fade_in"}`}
              >
                스마트한
              </span>
              선택인 이유!
            </h1>
            <h3>비하인드로 효율성을 높이고, 고객 만족도를 향상시켜보세요.</h3>
          </div>
          <div className="title mobileView">
            <h1>
              비하인드가
              <span
                ref={hideRefs[10]}
                className={` ${isVisible[10] ? "in_view fade_in" : "fade_in"}`}
              >
                스마트한
                <br />
              </span>
              선택인 이유!
            </h1>
            <h3>
              비하인드로 효율성을 높이고, <br />
              고객 만족도를 향상시켜보세요.
            </h3>
          </div>
          <div className="subContent">
            <div>
              <div className="numberText">01</div>
              <h2
                ref={hideRefs[2]}
                className={` ${isVisible[2] ? "in_view fade_up" : "fade_up"}`}
              >
                로그인 한번이면
                <br />
                온오프라인 모든기기 연동
              </h2>
              <h4>
                주문부터 고객호출까지 로그인 한번으로
                <br />
                모든 기기가 자동으로 연동돼요
              </h4>
            </div>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webHomepage02.png"
              alt="포스, pos, 테이블오더, did, kds, 로그인, 모바일주문, 카카오톡 모두 연동 가능한 비하인드(behind)"
              className="webHomepage02"
            />
          </div>
          <div className="subContent reverse">
            <div>
              <div className="numberText">02</div>
              <h2
                ref={hideRefs[3]}
                className={` ${isVisible[3] ? "in_view fade_up" : "fade_up"}`}
              >
                피크타임에는 인건비 절약
              </h2>
              <h4>
                메뉴주문, 결제 등 직원이 하는일을
                <br />
                테이블 오더 시스템을 이용해서 인건비를 줄일 수 있어요
              </h4>
            </div>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webHomepage03.png"
              alt="테이블 오더, 키오스크 등 직원이 하는일을 대신하는 비하인드(behind)"
              className="webHomepage03"
            />
          </div>
          <div className="subContent">
            <div>
              <div className="numberText">03</div>
              <h2
                ref={hideRefs[4]}
                className={` ${isVisible[4] ? "in_view fade_up" : "fade_up"}`}
              >
                매장 운영에 필요한
                <br />
                다양한 기능 제공
              </h2>
              <h4>
                편리한 매장운영을 위해
                <br />
                다양한 서비스를 제공해요
              </h4>
            </div>
            <div
              className="tabContent"
              style={{
                height: "500px",
              }}
            >
              <Tabs>
                <Tab label="알림톡 전송">
                  <img
                    src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webHomepage04-1.png"
                    alt="비하인드 카카오톡 알림톡 연동 기능제공"
                    className="webHomepage04"
                    style={{
                      width: "360px",
                    }}
                  />
                </Tab>
                <Tab label="선불 금액 충전">
                  <img
                    src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webHomepage04-2.png"
                    alt="비하인드 카카오톡 알림톡 캐시 카드등록및 자동충전 기능제공"
                    className="webHomepage04"
                  />
                </Tab>
                <Tab label="매출 달력">
                  <img
                    src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webHomepage04-3.png"
                    alt="비하인드 매출 및 매출달력 관리자페이지 제공"
                    className="webHomepage04"
                  />
                </Tab>
                <Tab label="상품 관리">
                  <img
                    src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webHomepage04-4.png"
                    alt="비하인드 사장님 셀프 메뉴등록및 관리할 수 있는 관리자페이지 제공"
                    className="webHomepage04"
                  />
                </Tab>
              </Tabs>
            </div>
          </div>
          <div className="subContent reverse">
            <div>
              <div className="numberText">04</div>
              <h2
                ref={hideRefs[5]}
                className={` ${isVisible[5] ? "in_view fade_up" : "fade_up"}`}
              >
                쇼핑몰, 복합매장에서도 이용 가능
              </h2>
              <h4>
                주문부터 고객호출까지 로그인 한번으로
                <br />
                모든 기기가 자동으로 연동돼요
              </h4>
            </div>
            <img
              src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webHomepage05.png"
              alt="쇼핑몰, 복합매장에서도 이용 가능한 테이블오더, 키오스크 비하인드"
              className="webHomepage05"
            />
          </div>
          <div className="subContent">
            <div>
              <div className="numberText">05</div>
              <h2
                ref={hideRefs[6]}
                className={` ${isVisible[6] ? "in_view fade_up" : "fade_up"}`}
              >
                매장 분위기에 따라
                <br />
                맞춤 인테리어 가능
              </h2>
              <h4>
                컬러를 선택할 수 있어서
                <br />
                분위기에 따라 커스터마이징이 가능해요
              </h4>
              <img
                src={`${process.env.PUBLIC_URL}/svg/colorGuide.svg`}
                alt="커스터마이징가능한 비하인드 키오스크"
                className="colorGuide"
              />
            </div>
            <div className="tabContent custom">
              <Tabs>
                <Tab label="DARK">
                  <img
                    src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webHomepage06-1.png"
                    alt="비하인드 카카오톡 알림톡 연동 기능제공"
                    className="webHomepage06"
                  />
                </Tab>
                <Tab label="WHITE">
                  <img
                    src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webHomepage06-2.png"
                    alt="비하인드 카카오톡 알림톡 캐시 카드등록및 자동충전 기능제공"
                    className="webHomepage06"
                  />
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
        <div className="content">
          <div className="title">
            <h1
              ref={hideRefs[7]}
              className={` ${isVisible[7] ? "in_view fade_up" : "fade_up"}`}
            >
              비하인드 공통 서비스
            </h1>
            <h3>비하인드 가맹점이라면 누구나, 무상으로 지원해드립니다</h3>
          </div>
          <img
            src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webHomepage07.png"
            alt="비하인드를 사용하고 매출을 증대시켜 보세요"
            className="webHomepage07"
          />
        </div>
        <div className="content">
          <div className="title">
            <h1
              ref={hideRefs[8]}
              className={` ${isVisible[8] ? "in_view fade_up" : "fade_up"}`}
            >
              우리매장 맞춤 선택지
            </h1>
            <h3 style={{ color: "#333" }}>
              비싼 비용에 터무니 없는 약정은 NO! 매장 상황에 맞게 맞춤형으로
              구매하세요!
            </h3>
          </div>
          <div className="flexButton">
            <button onClick={() => navigate("/contact")}>
              <img
                src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webHomepage08-1.png"
                alt="비하인드 구매방법"
                className="webHomepage08"
              />
            </button>
            <button
              onClick={() =>
                window.open("https://smartstore.naver.com/throo", "_blank")
              }
            >
              <img
                src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/webHomepage08-2.png"
                alt="비하인드를 구매방법"
                className="webHomepage08"
              />
            </button>
          </div>
        </div>
        <div className="content">
          <div className="title">
            <h1
              ref={hideRefs[9]}
              className={` ${isVisible[9] ? "in_view fade_up" : "fade_up"}`}
              style={{
                color: "#555",
              }}
            >
              365일 고객센터에 무엇이든 물어보세요
            </h1>
          </div>
          <div className="flexButton consulting">
            <a href="tel:1970-5324">
              <img
                src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock.ivid.kr/homepageWebButton01.png"
                alt="비하인드 전화 상담하기"
                className="webHomepage08"
              />
            </a>
            <button onClick={kakaoTalk}>
              <img
                src="https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock.ivid.kr/homepageWebButton02.png"
                alt="비하인드 카카오톡 채널에서 상담하기"
                className="webHomepage08"
              />
            </button>
          </div>
        </div>

        {/* floatingButton */}
        <div className="floatingButton webView">
          <button onClick={() => navigate("/contact")}>
            <img
              src={`${process.env.PUBLIC_URL}/img/consulting_inquiry.png`}
              alt="knockkncok 입점문의하기 버튼"
              style={{
                width: "100%",
                maxWidth: "110px",
              }}
            />
          </button>
          <button onClick={kakaoTalk}>
            <img
              src={`${process.env.PUBLIC_URL}/img/consulting_chatting.png`}
              alt="비하인드 카카오톡 채널에서 상담하기"
              style={{
                width: "100%",
                maxWidth: "110px",
              }}
            />
          </button>
        </div>

        <div className="floatingButton mobileView">
          {consultButton && (
            <div className="consultList">
              <button className="consult" onClick={() => navigate("/contact")}>
                상담문의
              </button>
              <button className="consult" onClick={kakaoTalk}>
                채팅하기
              </button>
            </div>
          )}
          <img
            src={`${process.env.PUBLIC_URL}/svg/consulting_mobile.svg`}
            alt="문의하기 버튼"
            className="consultButton"
            onClick={() => setConsultButton(!consultButton)}
          />
        </div>
      </div>
    </Style>
  );
};

export default MainHomePage;

const Style = styled.div`
  /* 공통 */
  h1,
  h3 {
    text-align: center;
  }
  h1 {
    font-size: 52px;
    font-weight: 700;
    color: #333;
    line-height: 67px;
  }
  h2 {
    font-size: 40px;
    font-weight: 700;
    color: #333;
    line-height: 52px;
  }
  h3 {
    font-size: 24px;
    font-weight: 400;
    color: #979797;
    line-height: 31px;
  }
  h4 {
    font-size: 24px;
    font-weight: 400;
    color: #646464;
    line-height: 38px;
  }
  p {
    font-size: 28px;
    font-weight: 500;
    line-height: 50px;
  }
  .numberText {
    font-size: 88px;
    font-weight: 700;
    line-height: 123px;
    color: #eeeeee;
  }
  img {
    width: 100%;
    vertical-align: top;
    margin-bottom: -1px;
  }
  .webView {
    display: block;
  }
  .mobileView {
    display: none !important;
  }

  /* wrapper */
  .wrapper {
    width: 100%;
    max-width: 100%;
  }

  /* banner */
  .slide {
    position: relative;
  }
  .buttonWrap {
    position: absolute;
    bottom: 27%;
    left: 19%;
    display: flex;
    flex-direction: column;
    gap: 26px;

    button {
      padding: 10px 33px 10px 56px;
      border: 2px solid;
      border-radius: 400px;
      font-size: 22px;
      font-weight: 600;
      line-height: 36px;

      img {
        width: 36px;
        margin: 0;
        margin-left: 14px;
      }
    }
  }

  /* content */
  .content {
    width: 100%;
    max-width: 100%;
    padding: 205px 330px 120px 330px;
    background: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .title {
      h1 {
        margin-bottom: 20px;

        span {
          padding: 0 10px;
          background: linear-gradient(90deg, #4dd2ae 36.44%, #5096ff 58.5%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          color: transparent;
        }
      }
    }
    img {
      width: 80%;
    }
  }
  .subContent {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 180px;
    h2 {
      margin-top: -60px;
      margin-bottom: 20px;
    }
    img {
      width: 45%;
    }
  }
  .subContent.reverse {
    flex-direction: row-reverse;
  }

  .tabContent {
    width: 600px;

    img {
      width: 85%;
      display: flex;
      margin: 0 auto;
      margin-top: 54px;
    }
  }
  .tabContent.custom {
    img {
      margin: 40px 0 0 0;
    }
  }
  .flexButton {
    margin-top: 120px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5%;

    button {
      width: auto;
    }
    button img:hover {
      box-shadow: 0px 0px 7.8px 2px #00000033;
      border-radius: 50px;
    }
  }
  .flexButton.consulting {
    gap: 0%;

    a,
    button {
      width: 500px;
    }
    button img:hover {
      box-shadow: none;
      border-radius: 0;
    }
  }
  .activeCheckIcon {
    display: none !important;
  }

  /* 이미지 설정 */
  .webHomepage01 {
    margin-top: 120px;
  }
  .webHomepage07 {
    margin-top: 120px;
  }
  .colorGuide {
    width: 100%;
    margin-top: 87px;
  }

  /* floatingButton */
  .floatingButton {
    width: auto;
    position: fixed;
    right: 0;
    bottom: 10px;
    padding: 3% 3vw;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    gap: 1vw;
  }
  .floatingButton.webView {
    flex-direction: column;
    bottom: 90px;
    padding: 0 3vw;
  }

  @media (max-width: 1700px) {
    .content {
      padding: 205px 150px 120px 150px;
    }
  }
  @media (max-width: 1400px) {
    .buttonWrap {
      bottom: 20%;
    }
    .content {
      padding: 205px 5% 120px 5%;
    }
    .flexButton.consulting {
      a,
      button {
        width: 100%;
      }
    }
  }

  /* 모바일 */
  @media (max-width: 1100px) {
    .webView {
      display: none;
    }
    .mobileView {
      display: block !important;
    }
    h1 {
      font-size: 38px;
      line-height: 42px;
    }
    .content {
      padding: 65px 5vw 40px 5vw;
    }
    .subContent,
    .subContent.reverse {
      margin-top: 50px;
      flex-direction: column;
      justify-content: center !important;
      align-items: center;
      text-align: center;
    }
    .subContent {
      h2 {
        margin-top: -50px;
      }
      h4 {
        margin-bottom: 30px;
      }
    }
    /* tabContent */
    .tabContent {
      width: 100%;
      height: auto !important;
    }
    .tabWrap {
      overflow-y: auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .tabContent.custom {
      width: 100%;
      text-align: center;

      .tabWrap {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
      }
      img {
        width: 100%;
        margin: 20px 0 0 0;
      }
    }
    .floatingButton.mobileView {
      .consultList {
        display: flex;
        flex-direction: column;
        justify-content: end;
        align-items: end;

        .consult {
          margin-bottom: 10px;
          padding: 11px 43px;
          font-size: 18px;
          font-weight: 600;
          border-radius: 50px;
          background: #000000;
          color: #fff;
        }
      }
      .consultButton {
        display: flex;
        margin-left: auto;
        max-width: 68px;
        height: 68px;
      }
    }

    /* 이미지 변경 */
    .webHomepage01 {
      content: url("https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobileHomepage01.png");
    }
    .webHomepage07 {
      width: 60% !important;
      content: url("https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobileHomepage02.png");
    }
    .colorGuide {
      width: 70% !important;
      margin: 10px 0 30px 0;
      content: url("https://web-image-file.s3.ap-northeast-2.amazonaws.com/behind.ivid.kr/mobileHomepage03.png");
    }
  }

  @media (max-width: 700px) {
    h1,
    h2,
    h3,
    h4 p {
      word-break: keep-all;
    }
    h1 {
      font-size: 28px;
      line-height: 36px;
    }
    h2 {
      margin-top: -30px;
      font-size: 20px;
      line-height: 26px;
    }
    h3 {
      font-size: 16px;
      line-height: 20px;
    }
    h4 {
      font-size: 14px;
      line-height: 22px;
    }
    p {
      font-size: 12px;
      line-height: 16px;
    }
    .content img {
      width: 100%;
    }
    .tabWrap {
      justify-content: flex-start;
    }

    .flexButton {
      margin-top: 30px;
      flex-direction: column;

      button {
        width: 90%;
        margin-bottom: 24px;
        box-shadow: 0px 0px 7.8px 2px #00000033;
        border-radius: 50px;
        border: 1px solid #e3e3e3;
      }
      button img:hover {
        box-shadow: none;
        border-radius: 0;
      }
      img {
        width: 85%;
      }
    }
    .flexButton.consulting button,
    .flexButton.consulting a {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
      box-shadow: none;
      border-radius: 0;
      border: none;
    }
    .floatingButton.mobileView {
      padding: 0 3vw;
    }

    /* 이미지 설정 */
    .webHomepage01 {
      margin-top: 50px;
    }
    .webHomepage04 {
      width: 90% !important;
    }
    .webHomepage07 {
      margin-top: 60px;
    }
    .colorGuide {
    }
  }
`;
